module.exports = __webpack_public_path__ + "static/media/ga-IE.b0c0ad7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/ga-IE.png
// module id = 946
// module chunks = 0